import './styles.css';

export const LandingItem = ({ item }) => {
  let Component = null;

  switch (item.ItemType) {
    case 'Text': {
      Component = (
        <div className="Question Notes">
          {item.Description.split('\n').map((el) => (
            <p className="description" key={el.substring(0, el.length - 2)}>
              {el}
              <br />
            </p>
          ))}
        </div>
      );
      break;
    }
    case 'Bullets': {
      Component = (
        <div className="Question Bullets">
          {item.Description.split('\n').map((el) => (
            <p className="description" key={el.substring(0, el.length - 2)}>
              {el}
              <br />
            </p>
          ))}
          <div className="bullets">
            <ul>
              {item.Options?.split('\n').map((el) => (
                <li
                  style={{
                    color: '#333',
                    fontSize: '17px',
                    lineHeight: '2.0625',
                  }}
                  key={el.substring(0, el.length - 2)}
                >
                  {el}
                </li>
              ))}
            </ul>
          </div>
        </div>
      );
      break;
    }
  }

  return Component;
};
